import * as _ from 'lodash';
import {Message} from 'react-chatbotify';

export class MessagesHelper {
  public static findMessageIndexByText(messages: Message[], content: string) {
    return _.findIndex(messages, {content});
  }

  public static getAIAssistantFlowMessages(messages: Message[], lastClosedFlowMessage: string) {
    const lastClosedFlowMessageIndex = MessagesHelper.findMessageIndexByText(messages, lastClosedFlowMessage);
    return messages.slice(lastClosedFlowMessageIndex + 1);
  }
}